<template lang="pug">
v-layout.page-home(fill-height)
  v-navigation-drawer(dark, persistent, :mini-variant='false', :clipped='clipped', v-model='drawer', enable-resize-watcher, fixed, app, floating)
    sidebar

  dfs-header(v-model='drawer', :clipped='clipped')

  v-content
    v-container.ml-0
      router-view(v-if='loaded')

  // v-footer.pr-3.pl-3(app)
    span &copy; {{ (new Date()).getFullYear() }} - Dealer Finance Services
    v-spacer
    span.mr-2 Help
    span Contact
</template>

<script>
export default {
  name: 'home',

  components: {
    Sidebar: require('./Sidebar').default,
    DfsHeader: require('./Header').default
  },

  data () {
    return {
      drawer: true,
      clipped: false,
      loaded: false
    }
  },

  async created () {
    await this.$store.dispatch('user/fetchMe')

    await this.$store.dispatch('organization/fetchDetails')

    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.page-home {
  margin-bottom: 100px; // Margin for the save container
}
</style>
